import { Action, Reducer } from "redux";
import { PredefinedSearchState, PredefinedSearchTypes, PredefinedSearchActionTypes } from "./predefinedSearchTypes";

const INITIAL_STATE: PredefinedSearchState = {
	predefinedSearch: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	domainPredefinedSearch: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const predefinedSearchReducer: Reducer<PredefinedSearchState> = (
	state: PredefinedSearchState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as PredefinedSearchActionTypes;
	switch (actionTypes.type) {
		case PredefinedSearchTypes.GET_DOMAIN_PREDEFINED_SEARCH:
			return {
				...state,
				domainPredefinedSearch: {
					...state.domainPredefinedSearch,
					isLoading: true,
				},
			};
		case PredefinedSearchTypes.SAVE_DOMAIN_PREDEFINED_SEARCH:
			return {
				...state,
				domainPredefinedSearch: {
					...state.domainPredefinedSearch,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case PredefinedSearchTypes.RESET_REDUCER_PREDEFINED_SEARCH:
			return {
				...state,
				domainPredefinedSearch: INITIAL_STATE.domainPredefinedSearch,
			};

		default:
			return state;
	}
};
export default predefinedSearchReducer;
